import {useEffect} from "react";
import {BreadCrumbs} from "../../../components/open/pages";
import '../../../static/css/home/about.css';
import {HomeInstagramComponent} from "../ig";

export const HomeAboutScreen = () => {
    useEffect(() => {
        document.title = "درباره نهال | مدرسه هوشمند نهال";
    }, []);
    return (
        <>
            <div style={{background: '#fff'}}>
                <div className="container-big">
                    <BreadCrumbs links={[
                        {title: 'درباره نهال', url: '/about'},
                    ]}/>
                </div>
                <div className="container">
                    <div className="home-about-section" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-6">
                                <h1>درباره نهال</h1>
                                <b>مدرسه هوشمند و مهارتی</b>
                                <p>
                                    مدرسه نهال اولین دبستان دخترانه با رویکرد مهارتی می‌باشد که واقع در شهرستان کاشمر
                                    می‌باشد. ما در دبستان نهال امید داریم که بتوانیم با ایجاد یک فضای مناسب و آموزش صحیح
                                    سهم مهمی در تربیت دانش‌آموزانمان داشته باشیم.
                                </p>
                            </div>
                            <div className="col-lg-6">
                                <img src="/images/about.jpg" alt="مدرسه نهال"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{background: '#fff', padding: '0 0 50px 0'}}>
                    <div className="container">
                        <HomeInstagramComponent/>
                    </div>
                </div>
            </div>
        </>
    );
};